import { CheckItem, MUTED } from '../Landing/ui';

function CrossItem({ children }) {
  return (
    <li className="tw-flex tw-items-start tw-gap-3">
      <span className="tw-mt-0.5 tw-flex tw-h-5 tw-w-5 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-amber-500/10 dark:tw-bg-amber-400/15">
        <svg
          className="tw-h-3 tw-w-3 tw-text-amber-700 dark:tw-text-amber-400"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fillRule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </span>
      <span className={`${MUTED} tw-text-[15px] tw-leading-relaxed`}>
        {children}
      </span>
    </li>
  );
}

// Travel etiquette as a customs declaration form: what to declare (dos)
// and what not to bring (don'ts), with the entry officer's stamp.
export default function CustomsCard({ travelEtiquette }) {
  if (
    !travelEtiquette ||
    ((!travelEtiquette.dos || travelEtiquette.dos.length === 0) &&
      (!travelEtiquette.donts || travelEtiquette.donts.length === 0))
  )
    return null;

  return (
    <div className="tw-relative tw-rounded-2xl tw-border-[1.5px] tw-border-dashed tw-border-[#C9C0AA] dark:tw-border-[#3A4D44] tw-bg-[#FFFDF6] dark:tw-bg-[#15231E] tw-p-6 sm:tw-p-8">
      <p className="tw-m-0 tw-pr-24 tw-font-mono tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-[0.28em] tw-text-primary-700 dark:tw-text-primary-300">
        Customs declaration · Travel etiquette
      </p>

      <span
        aria-hidden="true"
        className="tw-absolute tw-right-5 tw-top-5 tw-inline-block tw-rotate-6 tw-rounded-md tw-border-2 tw-border-solid tw-border-primary-600/50 dark:tw-border-primary-300/50 tw-px-2.5 tw-py-1 tw-font-mono tw-text-[9px] tw-font-semibold tw-tracking-[0.3em] tw-text-primary-700/70 dark:tw-text-primary-300/70"
      >
        CLEARED
      </span>

      <div className="tw-mt-6 tw-grid tw-gap-8 sm:tw-grid-cols-2">
        {travelEtiquette.dos && travelEtiquette.dos.length > 0 && (
          <div>
            <p className="tw-m-0 tw-mb-3 tw-font-mono tw-text-[9px] tw-font-medium tw-uppercase tw-tracking-[0.25em] tw-text-[#8A958F]">
              Declare
            </p>
            <ul className="tw-m-0 tw-flex tw-list-none tw-flex-col tw-gap-3 tw-p-0">
              {travelEtiquette.dos.map(ado => (
                <CheckItem key={ado}>{ado}</CheckItem>
              ))}
            </ul>
          </div>
        )}
        {travelEtiquette.donts && travelEtiquette.donts.length > 0 && (
          <div>
            <p className="tw-m-0 tw-mb-3 tw-font-mono tw-text-[9px] tw-font-medium tw-uppercase tw-tracking-[0.25em] tw-text-[#8A958F]">
              Do not bring
            </p>
            <ul className="tw-m-0 tw-flex tw-list-none tw-flex-col tw-gap-3 tw-p-0">
              {travelEtiquette.donts.map(adont => (
                <CrossItem key={adont}>{adont}</CrossItem>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
